import React from 'react'
import PropTypes from 'prop-types'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {isEditing, isPreviewing} from '@builder.io/sdk-react'
import {mockUserData} from './utils'

export const UserName = ({attributes, type}) => {
    const {
        data: customerData,
        isError: isCustomerError,
        error: customerError
    } = useCurrentCustomer()

    const isEdit = isEditing()
    const isPreview = isPreviewing()
    const customer = isEdit ? mockUserData : customerData

    const typeMap = {
        firstName: customer?.firstName || '',
        lastName: customer?.lastName || '',
        fullName:
            customer?.firstName && customer?.lastName
                ? `${customer.firstName} ${customer.lastName}`
                : ''
    }

    const name = typeMap[type]

    if (isCustomerError && isPreview) {
        throw new Error('There was an issue fetching customer data: ', customerError)
    }

    if (isCustomerError) {
        console.error('There was an issue fetching customer data: ', customerError)
        return null
    }

    if (!name) {
        return null
    }

    return <div {...attributes}>{name}</div>
}
UserName.propTypes = {
    attributes: PropTypes.object,
    type: PropTypes.string.isRequired
}
export const UserNameDefinition = {
    component: UserName,
    name: 'UserName',
    image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/user.svg',
    noWrap: true,
    inputs: [
        {
            name: 'type',
            type: 'string',
            enum: ['firstName', 'lastName', 'fullName'],
            defaultValue: 'firstName'
        }
    ]
}
